module.exports = "/_next/static/images/ThePayoff-xs@2x-af645b475fcbbe7f88af385aa021e7b5.png";